import React from 'react';
import { CheckBox, Input, RememberCheckBox, Icon } from './Checkbox.style';
import { Trans, useTranslation } from 'react-i18next';
import Tooltip from 'components/Tooltip';

const Checkbox = ({
  link,
  remember,
  id,
  type,
  name,
  title,
  value,
  setValue,
  labelStyle,
  exclaimation,
  tooltip,
  placement = 'bottom',
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {remember == true ? (
        <RememberCheckBox>
          <CheckBox>
            <Input
              type={type || 'checkbox'}
              name={name || 'check'}
              id={id || 'check'}
              checked={value}
              value={value}
              onChange={(e) => setValue(e.target.checked)}
            />
          </CheckBox>
          <label htmlFor={id || 'check'} style={{ ...labelStyle, cursor: 'pointer' }}>
            {t(title)}
          </label>
        </RememberCheckBox>
      ) : (
        <div className="d-flex mt-1">
          <CheckBox>
            <Input
              type={type || 'checkbox'}
              name={name || 'check'}
              id={id || 'check'}
              checked={value}
              value={value}
              onChange={(e) => setValue(e.target.checked)}
            />
          </CheckBox>
          <label htmlFor={id || 'check'} style={{ ...labelStyle, cursor: 'pointer' }}>
            {link ? (
              <Trans i18nKey={title}>
                <a href={link} target="_blank" rel="noreferrer" />
              </Trans>
            ) : (
              t(title)
            )}
            {exclaimation && (
              <Tooltip title={tooltip} placement={placement}>
                <Icon style={{ fontSize: '17px', padding: '0 5px' }} className=" fa fa-exclamation-circle orange" />
              </Tooltip>
            )}
          </label>
        </div>
      )}
    </React.Fragment>
  );
};

export default Checkbox;
